$(document).ready(function () {

    var slider_countdown = $('.countdown_top');
    var grid_countdown = $('.grid_countdown');
    var today = new Date();
    var due_date = new Date(2010, 3, 28, 0, 0, 0);

    if(today < due_date) {
        slider_countdown.countdown('2016/12/18 14:32:00', function (event) {
            var $this = $(this).html(event.strftime(''
                // + '<span>%d</span> gün '
                + '<span>%H</span> saat '
                + '<span>%M</span>:'
                + '<span>%S</span> '));

            $("#countdown_top_div").addClass("active-campaign");
            $("#campaign").hide();
            $("#showroom_top").removeClass("col-md-7");
            $("#showroom_top").addClass("col-md-5");

        }).on('finish.countdown', function (event) {
            $("#countdown_top_div").removeClass("active-campaign");
            $("#campaign").show();
            $("#showroom_top").removeClass("col-md-5");
            $("#showroom_top").addClass("col-md-7");

        });

        grid_countdown.countdown('2019/03/28 04:00:00', function (event) {
            var $this = $(this).html(event.strftime(''
                + '<span>%d</span> gün '
                + '<span>%H</span> saat '
                + '<span>%M</span>:'
                + '<span>%S</span> '));

            grid_countdown.addClass("active-campaign");
        }).on('finish.countdown', function (event) {

            grid_countdown.removeClass("active-campaign");

        });
    }
    if(grid_countdown.hasClass("active-campaign"))
        grid_countdown.removeClass("active-campaign");

    if($("#countdown_top_div").hasClass("active-campaign")){
        $("#countdown_top_div").removeClass("active-campaign");
        $("#campaign").show();
        $("#showroom_top").removeClass("col-md-5");
        $("#showroom_top").addClass("col-md-7");
    }


});